import { render } from "./trivia-question.vue?vue&type=template&id=809e91f6"
import script from "./trivia-question.vue?vue&type=script&lang=js"
export * from "./trivia-question.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__